
//import Popper from 'popperjs'
//import './node_modules/@popperjs/core/dist/esm/index.js';
//import * as Popper from './node_modules/@popperjs/core/dist/umd/popper.min.js';
//window.Popper = Popper;
//import * as Popper from "@popperjs/core"
//window.Popper = Popper;
// // import '@popperjs/core';
//import * from './node_modules/@popperjs/core/dist/esm/index.js';
//import { createPopper } from './node_modules/@popperjs/core/dist/esm/popper.js';
import { createPopper } from "@popperjs/core";
window.createPopper = createPopper;

// BS für Modal
// https://getbootstrap.com/docs/5.2/getting-started/parcel/
//import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";
//import * as bootstrap from "./node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

// Or import only needed plugins, specify which plugins you need:
// import { Tooltip, Toast, Popover } from 'bootstrap'

// Or import just one
//import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
window.bootstrap = bootstrap;

import DrDocWeb from "./drdocweb.js";

// --
// Bootstrap Modal

DrDocWeb.Modal = function (title, body, options) //, doc)
{
    if (DrDocWeb.IsNullOrEmpty(title) && DrDocWeb.IsNullOrEmpty(body)) {
        console.warn('DrDocWeb.Modal: empty arg title + body');
        return;
    }
    if (!DrDocWeb.IsNullOrEmpty(title) && DrDocWeb.IsNullOrEmpty(body)) {
        //body = title;
    }
    /*if (doc === undefined || doc === null)
    {
        doc = document;
    }*/
    //var doc = (elm.ownerDocument || document);
    var doc = document;
    if (body != undefined && typeof body !== 'string' && body.ownerDocument !== undefined) {
        doc = body.ownerDocument;
        //console.warn('Modal, body ist kein String..', title, body);
    }

    var id = 'modal-dialog-id-' + DrDocWeb.RandomChars(12);
    // https://getbootstrap.com/docs/5.0/components/modal/

    var modalClassName = 'modal drdoc-modal';
    var dialogClassName = 'modal-dialog modal-dialog-scrollable';


    let className = 'modal-content';
    //let attributesName = '';
    let optionBackdrop = true;

    if (options !== null && options !== undefined && typeof options === 'object') {
        if (options.fullScreen === true) // || fullScreen === undefined)
        {
            dialogClassName += ' modal-fullscreen';
        }
        else {
            let size = options.size ? options.size : 'xl';
            // automatisch full-screen, wenn kleiner als XXL
            dialogClassName += ` modal-${size} modal-fullscreen-${size}-down`;
            //dialogClassName += ' modal-xl modal-fullscreen-lg-down';
        }
        //if (options.scrollable === true || options.scrollable === undefined)
        //    dialogClassName += ' modal-fullscreen-sm-down'; // ' modal-xl'; // ' modal-lg';

        if (options.color == 'success')
            className = 'alert alert-success';
        else if (options.color == 'warning')
            className = 'alert alert-warning';
        else if (options.color == 'info')
            className = 'alert alert-info';
        else if (options.color == 'danger' || options.color == 'error')
            className = 'alert alert-danger';

        if (options.static === true)
            optionBackdrop = 'static';
        else if (options.backdrop === true)
            optionBackdrop = true;
        else if (options.backdrop === false)
            optionBackdrop = false;
    }

    let bodyHtml = `
      <div class="modal-body">

      </div>`;
    /*if (body !== undefined)
    {
        body = `
      <div class="modal-body">
        ${body}
      </div>`;
    }*/

    if (!DrDocWeb.IsNullOrEmpty(title)) {
        title = `
      <h5 class="modal-title">
        ${title.toHtmlEntities()}
      </h5>`;
    }

    let modalsAll = doc.querySelectorAll('.drdoc-modal');
    // console.log('Modals', modalsAll);
    if (modalsAll !== undefined && modalsAll !== null) {
        modalClassName += ' l' + (modalsAll.length + 1).toString();
        // die "active"-Klasse aus allen Modals entfernen
        for (let itm of modalsAll) {
            //$(modalsAll[i]).removeClass('active');
            itm.classList.remove('active');
        }
    }
    else {
        modalClassName += 'l0';
    }
    modalClassName += ' active';

    var elem = doc.createElement('div');
    // elem.innerHTML
    DrDocWeb.setInnerHTML(elem, `
<div class="${modalClassName}" x-tabindex="-1" id="${id}">
  <div class="${dialogClassName}">
    <div class="${className}">
      <div class="modal-header pt-2 pb-2 x-bg-gradient x-box x-bg-light">
        ${title}
        <!--<div style="margin-left: auto">
        <button type="button" class="btn btn-secondary">Prev</button>
        <button type="button" class="btn btn-secondary" onclick="">Next</button>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>-->
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onclick="DrDocWeb.ModalClose(this);"></button>
      </div>
      ${bodyHtml}
      <!--
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
      -->
    </div>
  </div>
</div>
    `, doc);

    // Modal DOM-Elem der Seite hinzufpgen
    // getElementById('modal-container')
    doc.body.appendChild(elem);

    // elem neu laden
    elem = doc.getElementById(id);

    if (elem === undefined || elem === null) {
        console.error('Modal: elem ist null, obwohl es gerade erstellt wurde', id);
    }

    var bs = new bootstrap.Modal(elem, {
        keyboard: true,
        focus: true,
        backdrop: optionBackdrop
    });

    console.log('BS Backdrop: ', optionBackdrop);

    // Wenn Body ein Element ist, dann als Element einbinden
    if (body != undefined) {
        let bodyModalElem = elem.querySelector('.modal-body');
        if (bodyModalElem != undefined) {
            if (typeof body === 'string') {
                if (body != title)
                    bodyModalElem.innerHTML = body; //.toHtmlEntities();
            }
            else {
                bodyModalElem.appendChild(body);
            }
        }
    }

    //setTimeout(function() {
    bs.show();
    //bs.toggle();
    //}, 1000);
    //bs.focus();

    // Event, wenn Modal geschlossen wird
    elem.addEventListener('hide.bs.modal', function (event) {
        //console.log('hide.bs.modal');
        let elem = doc.getElementById(id);
        elem.classList.add('hide');
        elem.classList.remove('active');

        // vorletztes Modal wieder aktivieren durch Setzen der "active"-Klasse
        let modalsAll = doc.querySelectorAll('.drdoc-modal');
        if (modalsAll !== undefined && modalsAll !== null && modalsAll.length > 1) {
            modalsAll[modalsAll.length - 2].classList.add('active');
        }
    });

    bs.close = function (event, removeChilds) {
        if (bs == null || bs._closed === true)
            return;
        bs._closed = true;

        //console.log('close hidden.bs.modal 1');
        bs.hide();

        // alle Elemente des Modal Content aus dem DOM entfernen
        if (removeChilds === undefined || removeChilds === true) {
            while (elem.firstChild) {
                elem.removeChild(elem.lastChild);
            }
        }

        //console.log('close hidden.bs.modal 2');
        setTimeout(function () {
            let elem = doc.getElementById(id);
            if (elem != undefined)
                elem.remove();
            if (bs != undefined)
                bs.dispose();
            //console.log('close hidden.bs.modal 3');
        }, 200);
    };

    // Beim schließen aus DOM entfernen
    elem.addEventListener('hidden.bs.modal', bs.close);

    return bs;
};
DrDocWeb.ModalSecondary = function (title, body) {
    return DrDocWeb.Modal(title, body, { color: 'secondary', fullScreen: false, size: 'lg' });
};
DrDocWeb.ModalInfo = function (title, body) {
    return DrDocWeb.Modal(title, body, { color: 'info', fullScreen: false, size: 'lg' });
};
DrDocWeb.ModalWarning = function (title, body) {
    return DrDocWeb.Modal(title, body, { color: 'warning', fullScreen: false, size: 'lg' });
};
DrDocWeb.ModalWarn = function (title, body) {
    return DrDocWeb.Modal(title, body, { color: 'warning', fullScreen: false, size: 'lg' });
};
DrDocWeb.ModalOk = function (title, body) {
    return DrDocWeb.Modal(title, body, { color: 'success', fullScreen: false, size: 'lg' });
};
DrDocWeb.ModalError = function (title, body) {
    return DrDocWeb.Modal(title, body, { color: 'danger', fullScreen: false, size: 'lg' });
};
DrDocWeb.GetModalError = function (title, body) {
    return function (error) {
        console.warn(error);
        return DrDocWeb.ModalError(title, body);
    };
};
DrDocWeb.ModalGet = function (element) {
    if (element === null || element === undefined)
        return undefined;
    if (typeof element === 'string')
        element = document.querySelector(element);
    

    if (element.classList !== undefined && element.classList.contains('drdoc-modal')) {
        //var modal = bootstrap.Modal.getOrCreateInstance(element);
        var modal = bootstrap.Modal.getInstance(element);
        return modal;
    }
    else if (element.parentNode !== undefined && element.parentNode !== null) {
        return DrDocWeb.ModalGet(element.parentNode);
    }
};
DrDocWeb.ModalClose = function (element, removeChilds) {
    let modal = DrDocWeb.ModalGet(element);

    if (modal !== null && modal !== undefined) {
        //modal.hide();
        modal.close(undefined, removeChilds);
        return true;
    }
    else {
        //console.log('DrDocWeb.ModalClose: Element nicht gefunden: ', element);
        return false;
    }
};


DrDocWeb.ModalProgress = function (title) {
    let progressBarId = 'progress-' + DrDocWeb.RandomChars(12);
    let progressBarHtml = `
<div id="${progressBarId}-spinner" class="d-flex justify-content-center">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div id="${progressBarId}" style="display: none;" class="progress" role="progressbar" aria-label="${title}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
    <div id="${progressBarId}-bar" class="progress-bar progress-bar-striped progress-bar-animated bg-primary" style="width: 0%;"></div>
</div>
`;

    let progressBarModal = DrDocWeb.ModalSecondary(title, progressBarHtml);

    progressBarModal.setPercentComplete = function (percentComplete) {
        // Spinner ausblenden und Bar einblenden, wenn Complete verwendet wird

        if (percentComplete == null || percentComplete == undefined)
            percentComplete = 0;
        if (percentComplete > 100)
            percentComplete = 100;

        console.log('Modal setPercentComplete = function (percentComplete) => ', percentComplete);
        
        let progressBarElem = document.getElementById(progressBarId);
        progressBarElem.style.display = 'block';
        progressBarElem.setAttribute('aria-valuenow', percentComplete);

        if (document.getElementById(progressBarId + '-spinner'))
        {
            document.getElementById(progressBarId + '-spinner').style.display = 'none!important';
            document.getElementById(progressBarId + '-spinner').classList.add('d-none');
        }
        if (document.getElementById(progressBarId + '-bar'))
        {
            document.getElementById(progressBarId + '-bar').style.width = percentComplete + '%';
            document.getElementById(progressBarId + '-bar').innerText = Math.round(percentComplete) + '%';
        }

    };
    //progressBarModal.setPercentComplete(0);

    return progressBarModal;
}

// --

// Bootstrap Wrapper
DrDocWeb.BS_TabShowFirst = function (containerElem) {
    if (containerElem == undefined || containerElem == null)
        containerElem = document;

    //if (typeof containerElem === 'string')
    var tabElems = containerElem.querySelectorAll('[data-bs-toggle="pill"], [data-bs-toggle="tab"]');

    if (tabElems != null && tabElems != undefined && tabElems.length > 0) {
        DrDocWeb.BS_TabShow(tabElems[0]);
    }

    tabElems.forEach(function (tabElem, tabIndex) {
        tabElem.addEventListener('click', function (e) {
            //console.log('Tab Click', tabIndex, e, tabElem);
            DrDocWeb.BS_TabShow(tabElems[tabIndex]);
            //DrDocWeb.BS_TabShow(e.target);
        });
    });
};

DrDocWeb.BS_TabShow = function (tabElem) {
    if (tabElem == null || tabElem == undefined)
        return undefined;
    if (typeof tabElem === 'string')
    {
        tabElem = DrDocWeb.BS_TabShow(document.querySelector(tabElem));
    }

    let elemTriggerBS = bootstrap.Tab.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Tab.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Tab(tabElem);

    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        }
        catch (Ex) {
            console.warn('DrDocWeb.BS_TabShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    }
    else {
        console.log('DrDocWeb.BS_TabShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    }
    return undefined;
};
DrDocWeb.BS_CollapseShow = function (tabElem) {
    if (tabElem == null || tabElem == undefined)
        return undefined;
    if (typeof tabElem === 'string')
        tabElem = document.querySelector(tabElem);
    
    let elemTriggerBS = bootstrap.Collapse.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Collapse.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Collapse(tabElem);

    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        }
        catch (Ex) {
            console.warn('DrDocWeb.BS_CollapseShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    }
    else {
        console.log('DrDocWeb.BS_CollapseShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    }
    return undefined;
};
DrDocWeb.BS_DropdownShow = function (tabElem) {
    if (tabElem == null || tabElem == undefined)
        return undefined;
    if (typeof tabElem === 'string')
        tabElem = document.querySelector(tabElem);
    
    let elemTriggerBS = bootstrap.Dropdown.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Dropdown.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Dropdown(tabElem);

    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        }
        catch (Ex) {
            console.warn('DrDocWeb.BS_DropdownShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    }
    else {
        console.log('DrDocWeb.BS_DropdownShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    }
    return undefined;
};
DrDocWeb.BS_TabHide = function (tabElem) {
    if (typeof tabElem === 'string')
        tabElem = document.querySelector(tabElem);
    
    let elemTriggerBS = bootstrap.Tab.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Tab.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Tab(tabElem);

    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.hide();
        }
        catch (Ex) {
            console.warn('DrDocWeb.BS_TabHide: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    }
    else {
        console.log('DrDocWeb.BS_TabHide: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    }
    return undefined;
};

DrDocWeb.BS_DropdownInit = function (triggerElem) {

    /*const dropdown = new bootstrap.Dropdown(triggerElem, {
        popperConfig(defaultBsPopperConfig) {
          // const newPopperConfig = {...}
          // use defaultBsPopperConfig if needed...
          // return newPopperConfig
        }
      });
      dropdown.update();*/

    triggerElem.removeEventListener('click', DrDocWeb.BS_Dropdown_OnClick);
    triggerElem.addEventListener('click', DrDocWeb.BS_Dropdown_OnClick);

    //let dropdown = bootstrap.Dropdown.getOrCreateInstance(triggerElem);
    //dropdown.update();
};
DrDocWeb.BS_Dropdown_OnClick = function (e) {
    // Dropdown anzeigen
    //e.preventDefault();
    if (e.target == undefined || e.target == null)
        return;
    let dropdownElem = e.target.parentNode.querySelector('.dropdown-menu');
    if (dropdownElem == undefined || dropdownElem == null)
        return;
    //dropdownElem.style.marginTop = '1.8rem';
    dropdownElem.style.position = 'absolute';
    //dropdownElem.style.transform = 'translate(148px)';
    if (dropdownElem.classList.contains('dropend'))
        dropdownElem.style.transform = `translate(${dropdownElem.parentNode.offsetWidth.toString()}px, -${dropdownElem.parentNode.offsetHeight.toString()}px)`;
    else
        dropdownElem.style.transform = `translate(0px, ${dropdownElem.parentNode.offsetHeight.toString()}px)`;

    dropdownElem.classList.toggle('show');


    console.log('BS_Dropdown_OnClick', e, this);

    //dropdownElem.trigger('click.bs.dropdown');
    //$(this).trigger('click.bs.dropdown');
    //$(this).trigger('show.bs.dropdown');

    let elemTriggerBS = bootstrap.Dropdown.getOrCreateInstance(e.target);
    //let elemTriggerBS = bootstrap.Dropdown.getInstance(this);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Dropdown(this);
    //console.log('BS_Dropdown_OnClick -> OPEN 1', e, elemTriggerBS._config);

    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        elemTriggerBS.update();
        //elemTriggerBS.toggle();
        //console.log(elemTriggerBS);
        return elemTriggerBS;
    }
    return undefined;
};

// onInitTargetElem (triggerElem, triggerElemSelector targetElem, cb_bs_elem_open, cb_bs_elem_close)
DrDocWeb.BS_Collapse = function (onInitTargetElem, onOpen, onClose) {
    // button[data-bs-toggle="collapse"]
    document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function (triggerElem) {
        if (triggerElem._hasHandler === true)
            return;
        triggerElem._hasHandler = true;
        //if (triggerElem.getAttribute('data-has-config-handler') == 'true')
        //    return;
        //triggerElem.setAttribute('data-has-config-handler', 'true');

        // Attribut [aria-expanded] verwenden, um die initiale
        let triggerElemExpandedValue = triggerElem.getAttribute('aria-expanded');
        let triggerElemExpanded = DrDocWeb.IsNullOrEmpty(triggerElemExpandedValue) ? null : (triggerElemExpandedValue == 'true');

        let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
        if (DrDocWeb.IsNullOrEmpty(triggerElemSelector)) {
            console.warn('Collapse ', 'elemSelector === undefined', triggerElem);
            return;
        }
        let confName = 'view/collapse-menu/' + triggerElemSelector.substring(1);

        let targetElem_arr = document.querySelectorAll(triggerElemSelector);
        if (targetElem_arr === undefined || targetElem_arr == null)
            console.warn('Collapse ', 'targetElem_arr === undefined', triggerElem);

        //console.log('Collapse New ', triggerElemSelector, targetElem_arr, confName);

        targetElem_arr.forEach(function (targetElem) {
            if (targetElem._hasHandler === true)
                return;
            targetElem._hasHandler = true;

            let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
            /*let bs_elem = bootstrap.Collapse.getInstance(targetElem);
            if (bs_elem == undefined || bs_elem == null)
            {
            bs_elem = new bootstrap.Collapse(targetElem, {
                toggle: false
            });
            }*/

            //let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
            if (bs_elem._hasHandler === true)
                return;
            bs_elem._hasHandler = true;

            //bs_elem.hide();
            //bs_elem._isOpen = false;

            const WAIT_TIME = 10;

            var bs_elem_open = function (signal) {
                bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
                //console.warn('[+] Target Show ', confName, triggerElemSelector, bs_elem);
                //DrDoc.configDevice.set(confName, true);
                bs_elem._isOpen = true;
                bs_elem.show();
                bs_elem._element.classList.add('show');
                triggerElem.setAttribute('aria-expanded', 'true');
                targetElem.classList.add('show');
                targetElem.classList.remove('collapsed');
                onOpen(triggerElem, triggerElemSelector);
                /*if (signal)
                {
                setTimeout(function () {
                    bs_elem_open(false);
                    //triggerElem.setAttribute('aria-expanded', 'true');
                    //targetElem.classList.add('show');
                    //if (window.updateMainMenuExpansion !== undefined)
                    //    window.updateMainMenuExpansion();
                    onOpen(triggerElem, triggerElemSelector);
                }, WAIT_TIME/2);
                }*/
            };
            var bs_elem_close = function (signal) {
                bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
                //console.warn('[-] Target Hide ', confName, triggerElemSelector, bs_elem);
                //DrDoc.configDevice.set(confName, false);
                bs_elem._isOpen = false;
                bs_elem.hide();
                triggerElem.setAttribute('aria-expanded', 'false');
                targetElem.classList.remove('show');
                targetElem.classList.add('collapsed');
                if (signal) {
                    setTimeout(function () {
                        bs_elem_close(false);
                        //triggerElem.setAttribute('aria-expanded', 'false');
                        //targetElem.classList.remove('show');
                        //if (window.updateMainMenuExpansion !== undefined)
                        //    window.updateMainMenuExpansion();
                        onClose(triggerElem, triggerElemSelector);
                    }, WAIT_TIME / 2);
                    setTimeout(function () {
                        bs_elem_close(false);
                    }, 2 * WAIT_TIME);
                    setTimeout(function () {
                        bs_elem_close(false);
                    }, 10 * WAIT_TIME);
                    setTimeout(function () {
                        bs_elem_close(false);
                    }, 50 * WAIT_TIME);
                }
            };
            //console.log('try close 1', bs_elem);

            bs_elem_close(false);
            if (triggerElemExpanded === true) {
                bs_elem_open(true);
            }
            else if (triggerElemExpanded === false) {
                //console.log('BS Collapse Init: Force Close: ', triggerElemExpanded, triggerElem);
                bs_elem_close(true);
                //setTimeout(function () { bs_elem_close(false); }, 1000);
            }

            // Collapse lässt sich nicht soofort schlieeßen!
            setTimeout(function () {

                //console.log('init', bs_elem);
                onInitTargetElem(triggerElem, triggerElemSelector, targetElem, bs_elem_open, bs_elem_close, triggerElemExpanded);
                /*console.log('try close 2');
                bs_elem_close(false);

                setTimeout(function () {
                    console.log('init')
                onInitTargetElem(triggerElem, triggerElemSelector, targetElem); //, bs_elem_open, bs_elem_close);
                //}, 5000);*/

                // Wenn irgendwo ins Dokument geklickt wird, das Dropdown schließen
                // Event handler erst nach ein paar Millisekunden aufrufen, da er sonst sofort aufgerufen wird, da gerade geklickt wird.
                /*triggerElem.addEventListener('click', function(e_click) {
                    console.log('BS_Collapse: onClick: triggerElem: ', e_click.target, triggerElem, targetElem);
                    bs_elem_close(true);
                });*/

                // Beim Click auf Menu Item, das Menü schließen
                if (DrDocWeb.IsMobile()) {
                    targetElem.querySelectorAll('a').forEach(function (targetElemLink) {
                        targetElemLink.addEventListener('click', function (e_click) {
                            console.log('BS_Collapse: onClick: targetElem: ', e_click.target, triggerElem, targetElem);
                            bs_elem_close(true);
                        });
                    });
                    targetElem.querySelectorAll('button').forEach(function (targetElemLink) {
                        targetElemLink.addEventListener('click', function (e_click) {
                            console.log('BS_Collapse: onClick: targetElem: ', e_click.target, triggerElem, targetElem);
                            bs_elem_close(true);
                        });
                    });
                }

            }, WAIT_TIME);


            triggerElem.addEventListener('click', function (e) {
                e.preventDefault();
                if (!bs_elem._isOpen)
                //if (!targetElem.classList.contains('show'))
                {
                    console.log('Menu is closed -> open: ', targetElem.className, targetElem.classList.contains('show'), bs_elem._isOpen);
                    bs_elem_open(true);
                }
                else {
                    console.log('Menu is open -> close: ', targetElem.className, targetElem.classList.contains('show'), bs_elem._isOpen);
                    bs_elem_close(true);
                }
            });

            /*
            //console.warn('DrDoc.configDevice.subscribeBool PRE ', confName);
            DrDoc.configDevice.subscribeBool(confName, function (valueNew, valueOld) {
                //let bs_elem = new bootstrap.Collapse(targetElem);
                //let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
                console.info('DrDoc.configDevice.subscribeBool POST ', confName, ' => ', valueNew); //, '  ', triggerElemSelector, bs_elem);

                //if (bs_elem) {
                    if (valueNew === true) {
                        bs_elem_open();
                    }
                    else {
                        bs_elem_close();
                    }
                //}
            }, false);

            triggerElem.addEventListener('click', function () {
                let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
                DrDoc.configDevice.set(confName, !bs_elem._isOpen);
            });*/
            /*targetElem.addEventListener('hidden.bs.collapse', function () {
                console.warn('Target Hide ', confName, triggerElemSelector, bs_elem);
                DrDoc.configDevice.set(confName, false);
                bs_elem._isOpen = false;
                bs_elem.hide();
            });
            targetElem.addEventListener('shown.bs.collapse', function () {
                console.warn('Target Show ', confName, triggerElemSelector, bs_elem);
                DrDoc.configDevice.set(confName, true);
                bs_elem._isOpen = true;
                bs_elem.show();
            });*/

        });
    });
};

// --

/*
DrDoc.BS_NavInitTabs = function(id)
{
    // Ersten Tab automatisch laden
    //var triggerTabList = document.querySelectorAll('#nav-tab button');
    //var triggerTab = document.querySelector('#nav-tab-' + id + ' button:first-child');
    //var triggerTab = document.querySelector('#' + id + ' button:first-child');
    var triggerTab = DrDocWeb.GetElement('#' + id);
    if (triggerTab !== undefined && triggerTab !== null)
    {
        let tabs = triggerTab.querySelectorAll('button'); //:first-child');
        
        console.log('BS_NavInitTabs', id); //, triggerTab);
        if (tabs === undefined || tabs === null)
        {
            console.warn('MaskLoadFirstTab: Erster Tab (BS) konnte nicht gefunden werden!', id);
        }
        else
        {
            if (tabs.length === 0)
            {
                console.warn('MaskLoadFirstTab: 0 Tabs gefunden', id);
            }
            else
            {
                //for (let i = 0; i < 1; i++)
                for (let i = 0; i < tabs.length; i++)
                {
                    let triggerEl = tabs[i];
                    let tabTriggerBS = bootstrap.Tab.getInstance(triggerEl);
                    if (tabTriggerBS === undefined || tabTriggerBS === null)
                        tabTriggerBS = new bootstrap.Tab(triggerEl);
                        
                    triggerEl.addEventListener('click', function (event) {
                        //console.log('Show!');
                        event.preventDefault();
                        tabTriggerBS.show();
                    });

                    if (i === 0)
                    {
                        //console.log('MaskLoadFirstTab: Erster Tab wurde geladen', id, i, tabTriggerBS);
                        //tabTriggerBS.show();

                    }
                    else
                    {
                        //console.log('MaskLoadFirstTab: X-ter Tab wurde geladen', id, i);
                        //tabTriggerBS.show();
                    }
                }
                for (let i = 0; i < 1; i++)
                {
                    let triggerEl = tabs[i];
                    let tabTriggerBS = bootstrap.Tab.getInstance(triggerEl);

                        setTimeout(function() {
                            tabTriggerBS.show();
                            console.log(tabTriggerBS);
                        }, 1000);
                }
            }
        }
    }
    else {
        console.warn('MaskLoadFirstTab: Erster Tab konnte nicht gefunden werden!', id);
    }
};*/

